__turbopack_context__.v({
  "close_btn": "Header-module-scss-module__ZOb-HG__close_btn",
  "close_icon_wrapper": "Header-module-scss-module__ZOb-HG__close_icon_wrapper",
  "header": "Header-module-scss-module__ZOb-HG__header",
  "title_button": "Header-module-scss-module__ZOb-HG__title_button",
  "title_text": "Header-module-scss-module__ZOb-HG__title_text",
});
